webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(1);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(157);
	
	var _componentsApp = __webpack_require__(158);
	
	var _componentsApp2 = _interopRequireDefault(_componentsApp);
	
	var _componentsLogo = __webpack_require__(197);
	
	var _componentsLogo2 = _interopRequireDefault(_componentsLogo);
	
	var _componentsSubtitle = __webpack_require__(198);
	
	var _componentsSubtitle2 = _interopRequireDefault(_componentsSubtitle);
	
	var _componentsParagraph = __webpack_require__(199);
	
	var _componentsParagraph2 = _interopRequireDefault(_componentsParagraph);
	
	var _componentsGamePlot = __webpack_require__(200);
	
	var _componentsGamePlot2 = _interopRequireDefault(_componentsGamePlot);
	
	var _componentsHowToPlay = __webpack_require__(243);
	
	var _componentsHowToPlay2 = _interopRequireDefault(_componentsHowToPlay);
	
	var root = document.createElement('div');
	document.body.appendChild(root);
	
	var viewport = {
	  width: document.documentElement.clientWidth
	};
	var plot = {
	  width: 150,
	  height: 100
	};
	if (viewport.width > 420) {
	  plot.width = 200;
	  plot.height = 100;
	}
	if (viewport.width > 520) {
	  plot.width = 400;
	  plot.height = 100;
	}
	
	(0, _reactDom.render)(_react2['default'].createElement(
	  _componentsApp2['default'],
	  null,
	  _react2['default'].createElement(_componentsLogo2['default'], null),
	  _react2['default'].createElement(_componentsSubtitle2['default'], null),
	  _react2['default'].createElement(_componentsGamePlot2['default'], { width: plot.width, height: plot.height }),
	  _react2['default'].createElement(_componentsHowToPlay2['default'], null)
	), root);

/***/ },

/***/ 1:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 158:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pureRenderDecorator = __webpack_require__(159);
	
	var _pureRenderDecorator2 = _interopRequireDefault(_pureRenderDecorator);
	
	var _radium = __webpack_require__(162);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var App = (function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, _App);
	
	    _get(Object.getPrototypeOf(_App.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { style: styles },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _App = App;
	  App = (0, _radium2['default'])(App) || App;
	  App = (0, _pureRenderDecorator2['default'])(App) || App;
	  return App;
	})(_react.Component);
	
	exports['default'] = App;
	
	var styles = {
	  width: '100%',
	  margin: 'auto',
	  padding: '1em',
	  '@media (min-width: 640px)': {
	    width: '640px'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 197:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pureRenderDecorator = __webpack_require__(159);
	
	var _pureRenderDecorator2 = _interopRequireDefault(_pureRenderDecorator);
	
	var _radium = __webpack_require__(162);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Logo = (function (_Component) {
	  _inherits(Logo, _Component);
	
	  function Logo() {
	    _classCallCheck(this, _Logo);
	
	    _get(Object.getPrototypeOf(_Logo.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Logo, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'h1',
	        { style: styles },
	        'Netwalk'
	      );
	    }
	  }]);
	
	  var _Logo = Logo;
	  Logo = (0, _pureRenderDecorator2['default'])(Logo) || Logo;
	  Logo = (0, _radium2['default'])(Logo) || Logo;
	  return Logo;
	})(_react.Component);
	
	exports['default'] = Logo;
	
	var styles = {
	  color: '#8EC170',
	  fontFamily: '"Courier New", "Courier", monospace',
	  fontSize: '45px',
	  fontWeight: 100,
	  margin: '1em 0 0',
	  textAlign: 'center',
	  '@media (min-width: 640px)': {
	    fontSize: '75px'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 198:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paragraph = __webpack_require__(199);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _pureRenderDecorator = __webpack_require__(159);
	
	var _pureRenderDecorator2 = _interopRequireDefault(_pureRenderDecorator);
	
	var _radium = __webpack_require__(162);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Subtitle = (function (_Component) {
	  _inherits(Subtitle, _Component);
	
	  function Subtitle() {
	    _classCallCheck(this, _Subtitle);
	
	    _get(Object.getPrototypeOf(_Subtitle.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Subtitle, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        _Paragraph2['default'],
	        null,
	        'Rotate pieces clockwise and connect all nodes ',
	        _react2['default'].createElement(
	          'strong',
	          null,
	          'to the server!'
	        )
	      );
	    }
	  }]);
	
	  var _Subtitle = Subtitle;
	  Subtitle = (0, _radium2['default'])(Subtitle) || Subtitle;
	  Subtitle = (0, _pureRenderDecorator2['default'])(Subtitle) || Subtitle;
	  return Subtitle;
	})(_react.Component);
	
	exports['default'] = Subtitle;
	module.exports = exports['default'];

/***/ },

/***/ 199:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pureRenderDecorator = __webpack_require__(159);
	
	var _pureRenderDecorator2 = _interopRequireDefault(_pureRenderDecorator);
	
	var _radium = __webpack_require__(162);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Paragraph = (function (_Component) {
	  _inherits(Paragraph, _Component);
	
	  function Paragraph() {
	    _classCallCheck(this, _Paragraph);
	
	    _get(Object.getPrototypeOf(_Paragraph.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Paragraph, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'p',
	        { style: [styles.base, this.props.styles] },
	        this.props.children
	      );
	    }
	  }]);
	
	  var _Paragraph = Paragraph;
	  Paragraph = (0, _radium2['default'])(Paragraph) || Paragraph;
	  Paragraph = (0, _pureRenderDecorator2['default'])(Paragraph) || Paragraph;
	  return Paragraph;
	})(_react.Component);
	
	exports['default'] = Paragraph;
	
	var styles = {
	  base: {
	    color: '#7B7B7B',
	    fontFamily: '"Helvetica Neue", "Helvetica", "Roboto", "Arial", sans-serif',
	    fontSize: '16px',
	    '@media (min-width: 640px)': {
	      fontSize: '22px'
	    },
	    fontWeight: '200',
	    margin: '2em 0',
	    lineHeight: '1.5em',
	    textAlign: 'center'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 200:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(157);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _NetwalkGame = __webpack_require__(201);
	
	var _NetwalkGame2 = _interopRequireDefault(_NetwalkGame);
	
	var _pureRenderDecorator = __webpack_require__(159);
	
	var _pureRenderDecorator2 = _interopRequireDefault(_pureRenderDecorator);
	
	var GamePlot = (function (_Component) {
	  _inherits(GamePlot, _Component);
	
	  function GamePlot() {
	    _classCallCheck(this, _GamePlot);
	
	    _get(Object.getPrototypeOf(_GamePlot.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(GamePlot, [{
	    key: 'render',
	    value: function render() {
	      var width = this.props.width,
	          height = this.props.height,
	          multiplier = 50;
	
	      // Convert 639 to 600, 231 to 200,
	      if (width >= multiplier) {
	        width -= width % multiplier;
	      } else {
	        width = multiplier;
	      }
	      if (height >= multiplier) {
	        height -= height % multiplier;
	      } else {
	        height = multiplier;
	      }
	
	      var difficulty_level = 1,
	          node_size = undefined;
	
	      if (width >= height) {
	        node_size = width / (width / multiplier) / difficulty_level;
	      } else if (height > width) {
	        node_size = height / (height / multiplier) / difficulty_level;
	      }
	
	      var rows = Math.floor(height / node_size);
	      var columns = Math.floor(width / node_size);
	
	      return _react2['default'].createElement(_NetwalkGame2['default'], {
	        rows: rows,
	        columns: columns,
	        animate: true,
	        animationWait: 100,
	        randomize: false });
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      width: _react.PropTypes.number,
	      height: _react.PropTypes.number
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      width: 300,
	      height: 300
	    },
	    enumerable: true
	  }]);
	
	  var _GamePlot = GamePlot;
	  GamePlot = (0, _pureRenderDecorator2['default'])(GamePlot) || GamePlot;
	  return GamePlot;
	})(_react.Component);
	
	exports['default'] = GamePlot;
	module.exports = exports['default'];

/***/ },

/***/ 201:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NetwalkUI = __webpack_require__(202);
	
	var _NetwalkUI2 = _interopRequireDefault(_NetwalkUI);
	
	var _Netwalk = __webpack_require__(206);
	
	var _Netwalk2 = _interopRequireDefault(_Netwalk);
	
	var _PlayButton = __webpack_require__(239);
	
	var _PlayButton2 = _interopRequireDefault(_PlayButton);
	
	var _LevelUp = __webpack_require__(240);
	
	var _LevelUp2 = _interopRequireDefault(_LevelUp);
	
	var _LevelDown = __webpack_require__(241);
	
	var _LevelDown2 = _interopRequireDefault(_LevelDown);
	
	var _Mask = __webpack_require__(242);
	
	var _Mask2 = _interopRequireDefault(_Mask);
	
	var _underscore = __webpack_require__(238);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _radium = __webpack_require__(162);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var NetwalkGame = (function (_Component) {
	  _inherits(NetwalkGame, _Component);
	
	  _createClass(NetwalkGame, null, [{
	    key: 'propTypes',
	    value: {
	      rows: _react.PropTypes.number,
	      columns: _react.PropTypes.number,
	      animate: _react.PropTypes.bool,
	      animationWait: _react.PropTypes.number,
	      randomize: _react.PropTypes.bool
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      rows: 3,
	      columns: 5,
	      animate: true,
	      animationWait: 10,
	      randomize: true
	    },
	    enumerable: true
	  }]);
	
	  function NetwalkGame(props) {
	    _classCallCheck(this, _NetwalkGame);
	
	    _get(Object.getPrototypeOf(_NetwalkGame.prototype), 'constructor', this).call(this, props);
	
	    this.state = {
	      matrix: [],
	      gameStarted: false,
	      gameEnded: false,
	      rows: this.props.rows
	    };
	  }
	
	  _createClass(NetwalkGame, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.generateMatrix({
	        rows: this.props.rows,
	        columns: this.props.columns,
	        animate: this.props.animate,
	        animationWait: this.props.animationWait,
	        randomize: this.props.randomize
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var Play = undefined,
	          Replay = undefined,
	          mask = undefined,
	          IncreaseDifficulty = undefined,
	          DecreaseDifficulty = undefined;
	
	      // Only show "Start Game" button if game has not yet started
	      if (!this.state.gameStarted && !this.state.gameEnded) {
	        Play = _react2['default'].createElement(_PlayButton2['default'], { onPlay: this.onPlay.bind(this), title: 'New Game' });
	      }
	
	      if (!this.state.gameStarted && this.state.gameEnded) {
	        Replay = _react2['default'].createElement(_PlayButton2['default'], { onPlay: this.onPlay.bind(this), title: 'Play again?' });
	      }
	
	      if (!this.state.gameStarted) {
	        mask = _react2['default'].createElement(_Mask2['default'], { opacity: 0.6 });
	      }
	      if (!this.state.gameStarted && this.state.gameEnded) {
	        mask = _react2['default'].createElement(_Mask2['default'], { opacity: 0.4 });
	      }
	
	      if (this.state.gameStarted && !this.state.gameEnded) {
	        IncreaseDifficulty = _react2['default'].createElement(_LevelUp2['default'], { onTrigger: this.addRow.bind(this) });
	
	        if (this.state.rows > 2) {
	          DecreaseDifficulty = _react2['default'].createElement(_LevelDown2['default'], { onTrigger: this.removeRow.bind(this) });
	        }
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        { style: styles.base },
	        _react2['default'].createElement(
	          'div',
	          { style: styles.difficultyContainer },
	          IncreaseDifficulty,
	          DecreaseDifficulty
	        ),
	        _react2['default'].createElement(
	          'div',
	          { style: [!this.state.gameStarted && !this.state.gameEnded && styles.blur] },
	          _react2['default'].createElement(_NetwalkUI2['default'], { matrix: this.state.matrix, onRotate: this.rotateNode.bind(this) })
	        ),
	        mask,
	        Play,
	        Replay
	      );
	    }
	  }, {
	    key: 'rotateNode',
	    value: function rotateNode(id) {
	      var matrix = this.Netwalk.rotateNode(id, this.state.matrix),
	          gameEnded = this.Netwalk.isMatrixSolved(matrix),
	          gameStarted = !gameEnded;
	
	      this.setState(_underscore2['default'].extend(this.state, {
	        matrix: matrix,
	        gameStarted: gameStarted,
	        gameEnded: gameEnded
	      }));
	    }
	  }, {
	    key: 'addRow',
	    value: function addRow() {
	      this.generateMatrix({
	        rows: this.state.rows + 1,
	        columns: this.props.columns,
	        animate: false,
	        randomize: true
	      });
	    }
	  }, {
	    key: 'removeRow',
	    value: function removeRow() {
	      if (this.state.rows > 2) {
	        this.generateMatrix({
	          rows: this.state.rows - 1,
	          columns: this.props.columns,
	          animate: false,
	          randomize: true
	        });
	      }
	    }
	  }, {
	    key: 'onPlay',
	    value: function onPlay() {
	      this.setState({
	        gameStarted: true,
	        gameEnded: false
	      });
	      this.generateMatrix({
	        rows: this.state.rows,
	        columns: this.props.columns,
	        animate: true,
	        animationWait: 10,
	        randomize: true
	      });
	    }
	  }, {
	    key: 'generateMatrix',
	    value: function generateMatrix(options) {
	
	      options = _underscore2['default'].extend({
	        rows: 3,
	        columns: 5,
	        animate: true,
	        animationWait: 100,
	        randomize: true
	      }, options);
	
	      this.Netwalk = new _Netwalk2['default']();
	
	      if (options.animate) {
	        this.Netwalk.generateMatrixAsync(options.rows, options.columns, (function (matrix) {
	          this.setState(_underscore2['default'].extend(this.state, {
	            rows: options.rows,
	            matrix: matrix
	          }));
	          if (options.randomize && this.Netwalk.isMatrixReady(matrix)) {
	            this.Netwalk.randomizeMatrixAsync(matrix, (function (matrix) {
	              this.setState(_underscore2['default'].extend(this.state, {
	                matrix: matrix
	              }));
	            }).bind(this), options.animationWait);
	          }
	        }).bind(this), options.animationWait);
	      } else {
	
	        var matrix = this.Netwalk.generateMatrix(options.rows, options.columns);
	        if (options.randomize) {
	          matrix = this.Netwalk.randomizeMatrix(matrix);
	        }
	        this.setState(_underscore2['default'].extend(this.state, {
	          rows: options.rows,
	          matrix: matrix
	        }));
	      }
	    }
	  }]);
	
	  var _NetwalkGame = NetwalkGame;
	  NetwalkGame = (0, _radium2['default'])(NetwalkGame) || NetwalkGame;
	  return NetwalkGame;
	})(_react.Component);
	
	var styles = {
	  base: {
	    position: 'relative'
	  },
	  difficultyContainer: {
	    display: 'flex',
	    flexDirection: 'row',
	    justifyContent: 'flex-start',
	    flexWrap: 'wrap',
	    alignItems: 'flex-start'
	  },
	  blur: {
	    filter: 'blur(3px) grayscale(100%)',
	    WebkitFilter: 'blur(3px) grayscale(100%)'
	  }
	};
	
	exports['default'] = NetwalkGame;
	module.exports = exports['default'];

/***/ },

/***/ 202:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(203);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Node = __webpack_require__(205);
	
	var _Node2 = _interopRequireDefault(_Node);
	
	var _pureRenderDecorator = __webpack_require__(159);
	
	var _pureRenderDecorator2 = _interopRequireDefault(_pureRenderDecorator);
	
	var NetwalkUI = (function (_Component) {
	  _inherits(NetwalkUI, _Component);
	
	  function NetwalkUI() {
	    _classCallCheck(this, _NetwalkUI);
	
	    _get(Object.getPrototypeOf(_NetwalkUI.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(NetwalkUI, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'NetwalkUI' },
	        this.renderNodes()
	      );
	    }
	  }, {
	    key: 'renderNodes',
	    value: function renderNodes() {
	      var _this = this;
	
	      return this.props.matrix.map(function (row) {
	        return _react2['default'].createElement(
	          'div',
	          { className: 'NetwalkUI-row' },
	          row.map(function (node) {
	            return _react2['default'].createElement(_Node2['default'], { key: 'node' + node.id,
	              id: node.id,
	              type: node.type,
	              connections: node.connections,
	              connected: node.connected,
	              onRotate: _this.props.onRotate });
	          })
	        );
	      });
	    }
	  }]);
	
	  var _NetwalkUI = NetwalkUI;
	  NetwalkUI = (0, _pureRenderDecorator2['default'])(NetwalkUI) || NetwalkUI;
	  return NetwalkUI;
	})(_react.Component);
	
	exports['default'] = NetwalkUI;
	module.exports = exports['default'];

/***/ },

/***/ 203:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 205:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pureRenderDecorator = __webpack_require__(159);
	
	var _pureRenderDecorator2 = _interopRequireDefault(_pureRenderDecorator);
	
	var Node = (function (_Component) {
	  _inherits(Node, _Component);
	
	  function Node() {
	    _classCallCheck(this, _Node);
	
	    _get(Object.getPrototypeOf(_Node.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Node, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: "NetwalkUI-node" + (this.props.connected ? '--connected' : ''),
	          onClick: this.rotate.bind(this) },
	        this.props.connections.map(function (connection) {
	          return _react2['default'].createElement('div', { className: "NetwalkUI-node-" + connection + "link" });
	        }),
	        this.props.type === 'computer' ? _react2['default'].createElement('div', { className: 'NetwalkUI-node-computer' }) : '',
	        this.props.type === 'server' ? _react2['default'].createElement('div', { className: 'NetwalkUI-node-server' }) : ''
	      );
	    }
	  }, {
	    key: 'rotate',
	    value: function rotate() {
	      this.props.onRotate(this.props.id);
	    }
	  }]);
	
	  var _Node = Node;
	  Node = (0, _pureRenderDecorator2['default'])(Node) || Node;
	  return Node;
	})(_react.Component);
	
	exports['default'] = Node;
	module.exports = exports['default'];

/***/ },

/***/ 206:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	__webpack_require__(207);
	
	var _nodeUuid = __webpack_require__(208);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	var _vektor = __webpack_require__(232);
	
	var _underscore = __webpack_require__(238);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var Netwalk = (function () {
	  function Netwalk() {
	    _classCallCheck(this, Netwalk);
	
	    this.directions = [{ name: 'up', vector: new _vektor.vector(0, -1) }, { name: 'down', vector: new _vektor.vector(0, 1) }, { name: 'left', vector: new _vektor.vector(-1, 0) }, { name: 'right', vector: new _vektor.vector(1, 0) }];
	
	    var figures = [];
	
	    // Elbows
	    figures.push({
	      type: 'elbow',
	      direction: 'upright',
	      connections: ['up', 'right']
	    });
	    figures.push({
	      type: 'elbow',
	      direction: 'rightdown',
	      connections: ['right', 'down']
	    });
	    figures.push({
	      type: 'elbow',
	      direction: 'downleft',
	      connections: ['down', 'left']
	    });
	    figures.push({
	      type: 'elbow',
	      direction: 'leftup',
	      connections: ['left', 'up']
	    });
	
	    // Lines
	    figures.push({
	      type: 'line',
	      direction: 'leftright',
	      connections: ['left', 'right']
	    });
	    figures.push({
	      type: 'line',
	      direction: 'updown',
	      connections: ['up', 'down']
	    });
	
	    // Tees
	    figures.push({
	      type: 'tee',
	      direction: 'leftupright',
	      connections: ['left', 'up', 'right']
	    });
	    figures.push({
	      type: 'tee',
	      direction: 'uprightdown',
	      connections: ['up', 'right', 'down']
	    });
	    figures.push({
	      type: 'tee',
	      direction: 'rightdownleft',
	      connections: ['right', 'down', 'left']
	    });
	    figures.push({
	      type: 'tee',
	      direction: 'downleftup',
	      connections: ['down', 'left', 'up']
	    });
	
	    // Computers
	    figures.push({
	      type: 'computer',
	      direction: 'up',
	      connections: ['up']
	    });
	    figures.push({
	      type: 'computer',
	      direction: 'right',
	      connections: ['right']
	    });
	    figures.push({
	      type: 'computer',
	      direction: 'down',
	      connections: ['down']
	    });
	    figures.push({
	      type: 'computer',
	      direction: 'left',
	      connections: ['left']
	    });
	
	    this.figures = figures;
	  }
	
	  _createClass(Netwalk, [{
	    key: 'isMatrixReady',
	    value: function isMatrixReady(matrix) {
	      for (var y in matrix) {
	        for (var x in matrix[y]) {
	          if (matrix[y][x].connections.length === 0) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	  }, {
	    key: 'isMatrixRandomized',
	    value: function isMatrixRandomized(matrix) {
	      for (var y in matrix) {
	        for (var x in matrix[y]) {
	          if (!matrix[y][x].randomized) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	  }, {
	    key: 'isMatrixSolved',
	    value: function isMatrixSolved(matrix) {
	      for (var y in matrix) {
	        for (var x in matrix[y]) {
	          if (!matrix[y][x].connected) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	  }, {
	    key: 'takeStepToBuildMatrix',
	    value: function takeStepToBuildMatrix(matrix) {
	
	      if (this.isMatrixReady(matrix)) {
	        return matrix;
	      }
	
	      var template = undefined;
	      var rows = matrix.length,
	          columns = matrix[0].length,
	          server = this.getServerNode(matrix);
	
	      if (!server) {
	
	        var x = _underscore2['default'].random(0, columns - 1),
	            y = _underscore2['default'].random(0, rows - 1);
	
	        server = _underscore2['default'].extend(matrix[y][x], {
	          type: 'server',
	          connected: true
	        });
	
	        matrix[y][x] = server;
	
	        var neighbors = this.getNeighborsReadyToConnectTo(server, matrix);
	        if (neighbors.length > 0) {
	          var random_neighbor = neighbors[_underscore2['default'].random(neighbors.length - 1)];
	          var connection_direction = this.getConnectionDirectionBetweenNodes(server, random_neighbor);
	          matrix = this.performDoubleSidedConnectBetween(server, random_neighbor, matrix);
	        }
	
	        // set server as configured
	        matrix[y][x] = _underscore2['default'].extend(matrix[y][x], {
	          configured: true
	        });
	
	        return matrix;
	      }
	
	      var unclosedNode = this.getUnclosedNodeConnectedTo(server, matrix);
	      if (unclosedNode) {
	        var neighbors = this.getNeighborsReadyToConnectTo(unclosedNode, matrix);
	        if (neighbors.length > 0) {
	          _underscore2['default'].each(neighbors, (function (neighbor) {
	            if (this.nodeCanAcceptNewConnections(unclosedNode, matrix)) {
	              matrix = this.performDoubleSidedConnectBetween(unclosedNode, neighbor, matrix);
	            }
	          }).bind(this));
	        }
	      }
	
	      return matrix;
	    }
	  }, {
	    key: 'nodeCanAcceptNewConnections',
	    value: function nodeCanAcceptNewConnections(node, matrix) {
	      if (node.connections.length >= 3) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'performDoubleSidedConnectBetween',
	    value: function performDoubleSidedConnectBetween(node1, node2, matrix) {
	      var connection_direction = this.getConnectionDirectionBetweenNodes(node1, node2);
	      matrix = this.connectNode(node1, connection_direction, matrix);
	      matrix = this.connectNode(node2, this.getOppositeDirectionOf(connection_direction), matrix);
	      return matrix;
	    }
	  }, {
	    key: 'getNodeTypeOf',
	    value: function getNodeTypeOf(node, matrix) {
	      switch (node.connections.length) {
	        case 3:
	          return 'tee';
	          break;
	        case 2:
	          if (_underscore2['default'].indexOf(node.connections, 'up') !== -1 && _underscore2['default'].indexOf(node.connections, 'down') !== -1 || _underscore2['default'].indexOf(node.connections, 'left') !== -1 && _underscore2['default'].indexOf(node.connections, 'right') !== -1) {
	            return 'line';
	          }
	          return 'elbow';
	          break;
	        case 1:
	          return 'computer';
	          break;
	      }
	    }
	  }, {
	    key: 'connectNode',
	    value: function connectNode(node, direction, matrix) {
	      var x = node.vector.x,
	          y = node.vector.y,
	          connections = _underscore2['default'].union([direction], node.connections);
	
	      matrix[y][x] = node = _underscore2['default'].extend(node, {
	        direction: this.getDirectionByConnections(connections),
	        connections: connections
	      });
	
	      matrix[y][x] = node = _underscore2['default'].extend(node, {
	        type: node.type === 'server' ? 'server' : this.getNodeTypeOf(node, matrix)
	      });
	
	      // set node as "configured" if that is it's 3rd connection
	      // or if there are simply no available nodes to connect to
	      var neighbors = this.getNeighborsReadyToConnectTo(node, matrix);
	      if (neighbors.length === 0 || connections.length === 3) {
	        matrix[y][x] = node = _underscore2['default'].extend(matrix[y][x], {
	          configured: true
	        });
	      }
	
	      return matrix;
	    }
	  }, {
	    key: 'getDirectionByConnections',
	    value: function getDirectionByConnections(connections) {
	      if (_underscore2['default'].indexOf(connections, 'left') !== -1 && _underscore2['default'].indexOf(connections, 'up') !== -1 && _underscore2['default'].indexOf(connections, 'right') !== -1) {
	        return 'leftupright';
	      }
	      if (_underscore2['default'].indexOf(connections, 'up') !== -1 && _underscore2['default'].indexOf(connections, 'right') !== -1 && _underscore2['default'].indexOf(connections, 'down') !== -1) {
	        return 'uprightdown';
	      }
	      if (_underscore2['default'].indexOf(connections, 'right') !== -1 && _underscore2['default'].indexOf(connections, 'down') !== -1 && _underscore2['default'].indexOf(connections, 'left') !== -1) {
	        return 'rightdownleft';
	      }
	      if (_underscore2['default'].indexOf(connections, 'down') !== -1 && _underscore2['default'].indexOf(connections, 'left') !== -1 && _underscore2['default'].indexOf(connections, 'up') !== -1) {
	        return 'downleftup';
	      }
	
	      if (_underscore2['default'].indexOf(connections, 'up') !== -1 && _underscore2['default'].indexOf(connections, 'right') !== -1) {
	        return 'upright';
	      }
	      if (_underscore2['default'].indexOf(connections, 'right') !== -1 && _underscore2['default'].indexOf(connections, 'down') !== -1) {
	        return 'rightdown';
	      }
	      if (_underscore2['default'].indexOf(connections, 'down') !== -1 && _underscore2['default'].indexOf(connections, 'left') !== -1) {
	        return 'downleft';
	      }
	      if (_underscore2['default'].indexOf(connections, 'left') !== -1 && _underscore2['default'].indexOf(connections, 'up') !== -1) {
	        return 'leftup';
	      }
	
	      if (_underscore2['default'].indexOf(connections, 'up') !== -1 && _underscore2['default'].indexOf(connections, 'down') !== -1) {
	        return 'updown';
	      }
	      if (_underscore2['default'].indexOf(connections, 'left') !== -1 && _underscore2['default'].indexOf(connections, 'right') !== -1) {
	        return 'leftright';
	      }
	
	      if (_underscore2['default'].indexOf(connections, 'up') !== -1) {
	        return 'up';
	      }
	      if (_underscore2['default'].indexOf(connections, 'right') !== -1) {
	        return 'right';
	      }
	      if (_underscore2['default'].indexOf(connections, 'down') !== -1) {
	        return 'down';
	      }
	      if (_underscore2['default'].indexOf(connections, 'left') !== -1) {
	        return 'left';
	      }
	    }
	  }, {
	    key: 'getNeighborsOf',
	    value: function getNeighborsOf(node, matrix) {
	      var neighbors = [];
	      _underscore2['default'].each(this.directions, (function (direction) {
	        var neighbor = this.findNodeByVector(node.vector.add(direction.vector), matrix);
	        if (neighbor) {
	          neighbors.push(neighbor);
	        }
	      }).bind(this));
	      return neighbors;
	    }
	  }, {
	    key: 'getNeighborsReadyToConnectTo',
	    value: function getNeighborsReadyToConnectTo(node, matrix) {
	      var neighbors = [];
	
	      if (node.configured) {
	        return [];
	      }
	
	      _underscore2['default'].each(this.directions, (function (direction) {
	
	        // Avoid already connected neighbors
	        if (_underscore2['default'].indexOf(node.connections, direction) !== -1) {
	          return;
	        }
	
	        var neighbor = this.findNodeByVector(node.vector.add(direction.vector), matrix);
	
	        if (neighbor && !neighbor.configured && !this.nodesAreIndirectlyConnected(node, neighbor, matrix)) {
	          neighbors.push(neighbor);
	        }
	      }).bind(this));
	
	      return neighbors;
	    }
	  }, {
	    key: 'nodesAreIndirectlyConnected',
	    value: function nodesAreIndirectlyConnected(node1, node2, matrix) {
	      var connection_direction = this.getConnectionDirectionBetweenNodes(node1, node2);
	      return this.findNodeConnectedTo(node1, node2, connection_direction, matrix);
	    }
	  }, {
	    key: 'findNodeConnectedTo',
	    value: function findNodeConnectedTo(node1, needle, exceptDirection, matrix) {
	      if (node1.id === needle.id) {
	        return true;
	      }
	
	      var connected_neighbors = this.getConnectedNeighborsOf(node1, exceptDirection, matrix);
	      if (connected_neighbors.length > 0) {
	        for (var i in connected_neighbors) {
	          var neighbor = connected_neighbors[i];
	          var connection_direction = this.getConnectionDirectionBetweenNodes(node1, neighbor);
	          if (this.findNodeConnectedTo(neighbor, needle, this.getOppositeDirectionOf(connection_direction), matrix)) {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'getUnclosedNodeConnectedTo',
	    value: function getUnclosedNodeConnectedTo(node, matrix) {
	      var nodes = this.getUnclosedNodesConnectedTo(node, null, matrix);
	      var picked_node = undefined;
	      if (nodes.length > 0) {
	        picked_node = nodes[_underscore2['default'].random(nodes.length - 1)];
	      }
	      return picked_node;
	    }
	  }, {
	    key: 'getUnclosedNodesConnectedTo',
	    value: function getUnclosedNodesConnectedTo(node, exceptDirection, matrix) {
	
	      // If this node is not marked as "configured" then it is considered
	      // unclosed so we return it
	      if (!node.configured) {
	        return [node];
	      }
	
	      if (this.getNeighborsReadyToConnectTo(node, matrix).length > 0) {
	        return [node];
	      }
	
	      var unclosed_nodes = [];
	
	      var connected_nodes = this.getConnectedNeighborsOf(node, exceptDirection, matrix);
	
	      _underscore2['default'].each(connected_nodes, (function (connected_node) {
	        var unclosed_children = this.getUnclosedNodesConnectedTo(connected_node, this.getConnectionDirectionBetweenNodes(connected_node, node), matrix);
	        if (unclosed_children) {
	          _underscore2['default'].each(unclosed_children, function (unclosed_child) {
	            unclosed_nodes.push(unclosed_child);
	          });
	        }
	      }).bind(this));
	
	      return unclosed_nodes;
	    }
	  }, {
	    key: 'nodeHasEmptyNeighbors',
	    value: function nodeHasEmptyNeighbors(node, matrix) {
	      var surrounding_nodes = this.getNeighborsOf(node, matrix);
	      for (var i in surrounding_nodes) {
	        var neighbor = surrounding_nodes[i];
	        if (neighbor.connections.length === 0) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'markConfiguredNodes',
	    value: function markConfiguredNodes(matrix) {
	      for (var y in matrix) {
	        for (var x in matrix[y]) {
	          var node = matrix[y][x];
	          if (!node.configured && node.connections.length > 0 && !this.nodeHasEmptyNeighbors(node, matrix)) {
	            matrix[y][x] = _underscore2['default'].extend(matrix[y][x], {
	              configured: true
	            });
	          }
	        }
	      }
	      return matrix;
	    }
	  }, {
	    key: 'initializeMatrix',
	    value: function initializeMatrix(rows, columns) {
	      var matrix = new Array(rows);
	      for (var y = 0; y < rows; ++y) {
	        matrix[y] = new Array(columns);
	        for (var x = 0; x < columns; ++x) {
	          matrix[y][x] = {
	            id: _nodeUuid2['default'].v4(),
	            type: null,
	            direction: null,
	            connections: [],
	            configured: false,
	            connected: false,
	            randomized: false,
	            vector: new _vektor.vector(x, y)
	          };
	        }
	      }
	      return matrix;
	    }
	  }, {
	    key: 'takeStepToRandomizeMatrix',
	    value: function takeStepToRandomizeMatrix(matrix) {
	      var rows = matrix.length,
	          columns = matrix[0].length,
	          y = _underscore2['default'].random(rows - 1),
	          x = _underscore2['default'].random(columns - 1);
	
	      var node = matrix[y][x];
	      if (node.randomized) {
	        if (this.isMatrixRandomized(matrix)) {
	          return matrix;
	        }
	        return this.takeStepToRandomizeMatrix(matrix);
	      }
	
	      for (var i = 0; i <= _underscore2['default'].random(3); i++) {
	        matrix = this.rotateNode(matrix[y][x].id, matrix);
	      }
	      matrix[y][x].randomized = true;
	
	      return matrix;
	    }
	  }, {
	    key: 'randomizeMatrixAsync',
	    value: function randomizeMatrixAsync(matrix, callback, interval) {
	      interval = interval || 10;
	
	      var randomize = (function (timestamp) {
	
	        matrix = this.takeStepToRandomizeMatrix(matrix);
	        matrix = this.getRecalculatedMatrix(matrix);
	
	        if (typeof callback === 'function') {
	          callback(matrix);
	        }
	
	        if (!this.isMatrixRandomized(matrix)) {
	          setTimeout(function () {
	            window.requestAnimationFrame(randomize);
	          }, interval);
	        }
	      }).bind(this);
	      window.requestAnimationFrame(randomize);
	    }
	  }, {
	    key: 'randomizeMatrix',
	    value: function randomizeMatrix(matrix) {
	
	      while (!this.isMatrixRandomized(matrix)) {
	        matrix = this.takeStepToRandomizeMatrix(matrix);
	        matrix = this.getRecalculatedMatrix(matrix);
	      }
	
	      return matrix;
	    }
	  }, {
	    key: 'generateMatrixAsync',
	    value: function generateMatrixAsync(rows, columns, callback, interval) {
	      var matrix = this.initializeMatrix(rows, columns);
	      interval = interval || 10;
	
	      var generate = (function (timestamp) {
	
	        matrix = this.takeStepToBuildMatrix(matrix);
	        matrix = this.markConfiguredNodes(matrix);
	        matrix = this.getRecalculatedMatrix(matrix);
	
	        if (typeof callback === 'function') {
	          callback(matrix);
	        }
	
	        if (!this.isMatrixReady(matrix)) {
	          setTimeout(function () {
	            window.requestAnimationFrame(generate);
	          }, interval);
	        }
	      }).bind(this);
	      window.requestAnimationFrame(generate);
	    }
	  }, {
	    key: 'generateMatrix',
	    value: function generateMatrix(rows, columns) {
	      var matrix = this.initializeMatrix(rows, columns);
	
	      while (!this.isMatrixReady(matrix)) {
	        matrix = this.takeStepToBuildMatrix(matrix);
	        matrix = this.markConfiguredNodes(matrix);
	        matrix = this.getRecalculatedMatrix(matrix);
	      }
	
	      return matrix;
	    }
	  }, {
	    key: 'rotateNode',
	    value: function rotateNode(id, matrix) {
	      var node = this.findNodeById(id, matrix);
	
	      if (!node) {
	        return;
	      }
	
	      var current_direction = node.direction;
	      var new_direction = '';
	      var new_connections = [];
	
	      switch (current_direction) {
	        // Elbows
	        case 'upright':
	          new_direction = 'rightdown';
	          new_connections = ['right', 'down'];
	          break;
	        case 'rightdown':
	          new_direction = 'downleft';
	          new_connections = ['down', 'left'];
	          break;
	        case 'downleft':
	          new_direction = 'leftup';
	          new_connections = ['left', 'up'];
	          break;
	        case 'leftup':
	          new_direction = 'upright';
	          new_connections = ['up', 'right'];
	          break;
	
	        // Tees
	        case 'leftupright':
	          new_direction = 'uprightdown';
	          new_connections = ['up', 'right', 'down'];
	          break;
	        case 'uprightdown':
	          new_direction = 'rightdownleft';
	          new_connections = ['right', 'down', 'left'];
	          break;
	        case 'rightdownleft':
	          new_direction = 'downleftup';
	          new_connections = ['down', 'left', 'up'];
	          break;
	        case 'downleftup':
	          new_direction = 'leftupright';
	          new_connections = ['left', 'up', 'right'];
	          break;
	
	        // Computers and server
	        case 'up':
	          new_direction = 'right';
	          new_connections = ['right'];
	          break;
	        case 'right':
	          new_direction = 'down';
	          new_connections = ['down'];
	          break;
	        case 'down':
	          new_direction = 'left';
	          new_connections = ['left'];
	          break;
	        case 'left':
	          new_direction = 'up';
	          new_connections = ['up'];
	          break;
	
	        // Lines
	        case 'leftright':
	          new_direction = 'updown';
	          new_connections = ['up', 'down'];
	          break;
	        case 'updown':
	          new_direction = 'leftright';
	          new_connections = ['left', 'right'];
	          break;
	      }
	
	      matrix[node.vector.y][node.vector.x].direction = new_direction;
	      matrix[node.vector.y][node.vector.x].connections = new_connections;
	
	      matrix = this.getRecalculatedMatrix(matrix);
	
	      return matrix;
	    }
	  }, {
	    key: 'getRecalculatedMatrix',
	    value: function getRecalculatedMatrix(matrix) {
	      var connectedNodes = this.getAllNodesConnectedToServer(matrix);
	
	      for (var x in matrix) {
	        var _loop = function (y) {
	          var node = matrix[x][y];
	          if (node.type === 'server' || connectedNodes.findIndex(function (n) {
	            return n.id === node.id;
	          }) >= 0) {
	            matrix[x][y].connected = true;
	          } else {
	            matrix[x][y].connected = false;
	          }
	        };
	
	        for (var y in matrix[x]) {
	          _loop(y);
	        }
	      }
	
	      return matrix;
	    }
	  }, {
	    key: 'getAllNodesConnectedToServer',
	    value: function getAllNodesConnectedToServer(matrix) {
	      var server = this.getServerNode(matrix);
	      return this.getAllNodesConnectedToNode(server, null, matrix);
	    }
	  }, {
	    key: 'getAllNodesConnectedToNode',
	    value: function getAllNodesConnectedToNode(node, exceptDirection, matrix, current_nodes) {
	      current_nodes = current_nodes || [];
	      var connected_nodes = [];
	      var connected_neighbors = this.getConnectedNeighborsOf(node, exceptDirection, matrix);
	
	      if (connected_neighbors.length > 0) {
	
	        _underscore2['default'].each(connected_neighbors, (function (neighbor) {
	
	          // Stop the recursion if this node was already served before
	          if (_underscore2['default'].indexOf(current_nodes, neighbor) !== -1) {
	            return;
	          }
	
	          connected_nodes.push(neighbor);
	
	          var nodes_connected_to_neighbor = this.getAllNodesConnectedToNode(neighbor, this.getConnectionDirectionBetweenNodes(neighbor, node), matrix, _underscore2['default'].union(current_nodes, connected_neighbors));
	
	          _underscore2['default'].each(nodes_connected_to_neighbor, function (node_connected_to_neighbor) {
	            connected_nodes.push(node_connected_to_neighbor);
	          });
	        }).bind(this));
	      }
	
	      return connected_nodes;
	    }
	  }, {
	    key: 'getConnectionDirectionBetweenNodes',
	    value: function getConnectionDirectionBetweenNodes(node1, node2) {
	      var x1 = node1.vector.x,
	          x2 = node2.vector.x,
	          y1 = node1.vector.y,
	          y2 = node2.vector.y;
	
	      if (x1 === x2 && y1 < y2) {
	        return 'down';
	      } else if (x1 === x2 && y1 > y2) {
	        return 'up';
	      } else if (y1 === y2 && x1 < x2) {
	        return 'right';
	      } else if (y1 === y2 && x1 > x2) {
	        return 'left';
	      }
	
	      return;
	    }
	  }, {
	    key: 'getConnectedNeighborsOf',
	    value: function getConnectedNeighborsOf(node, exceptDirection, matrix) {
	      var connectedNodes = [];
	
	      var directions = [{ name: 'up', vector: new _vektor.vector(0, -1) }, { name: 'down', vector: new _vektor.vector(0, 1) }, { name: 'left', vector: new _vektor.vector(-1, 0) }, { name: 'right', vector: new _vektor.vector(1, 0) }];
	
	      _underscore2['default'].each(directions, (function (direction) {
	
	        if (exceptDirection === direction.name) {
	          return;
	        }
	
	        var neighbor = this.findNodeByVector(node.vector.add(direction.vector), matrix);
	
	        if (!neighbor) {
	          return;
	        }
	
	        if (this.nodesAreConnected(node, neighbor, matrix)) {
	          connectedNodes.push(neighbor);
	        }
	      }).bind(this));
	
	      return connectedNodes;
	    }
	  }, {
	    key: 'nodesAreConnected',
	    value: function nodesAreConnected(node1, node2, matrix) {
	      var xdiff = Math.abs(node1.vector.x - node2.vector.x);
	      var ydiff = Math.abs(node1.vector.y - node2.vector.y);
	      if (xdiff > 0 && ydiff > 0) {
	        return false;
	      }
	
	      var conn1 = node1.connections;
	      var conn2 = node2.connections;
	
	      var node1IsOnHigherRow = node1.vector.y < node2.vector.y;
	      var node2IsOnHigherRow = node1.vector.y > node2.vector.y;
	      var nodesAreOnSameRow = node1.vector.y === node2.vector.y;
	      var node1IsOnFartherColumn = node1.vector.x > node2.vector.x;
	      var node2IsOnFartherColumn = node1.vector.x < node2.vector.x;
	      var nodesAreOnSameColumn = node1.vector.x === node2.vector.x;
	
	      if (conn1.findIndex(function (c) {
	        return c === 'up';
	      }) >= 0 && conn2.findIndex(function (c) {
	        return c === 'down';
	      }) >= 0 && node2IsOnHigherRow && nodesAreOnSameColumn) {
	        // console.log("Node " + node1.vector.x + "," + node1.vector.y + " is connected with " + node2.vector.x + "," + node2.vector.y + " because of UP to DOWN connection", node1, node2);
	        return true;
	      }
	
	      if (conn1.findIndex(function (c) {
	        return c === 'down';
	      }) >= 0 && conn2.findIndex(function (c) {
	        return c === 'up';
	      }) >= 0 && node1IsOnHigherRow && nodesAreOnSameColumn) {
	        // console.log("Node " + node1.vector.x + "," + node1.vector.y + " is connected with " + node2.vector.x + "," + node2.vector.y + " because of DOWN to UP connection", node1, node2);
	        return true;
	      }
	      if (conn1.findIndex(function (c) {
	        return c === 'left';
	      }) >= 0 && conn2.findIndex(function (c) {
	        return c === 'right';
	      }) >= 0 && node1IsOnFartherColumn && nodesAreOnSameRow) {
	        // console.log("Node " + node1.vector.x + "," + node1.vector.y + " is connected with " + node2.vector.x + "," + node2.vector.y + " because of LEFT to RIGHT connection", node1, node2);
	        return true;
	      }
	      if (conn1.findIndex(function (c) {
	        return c === 'right';
	      }) >= 0 && conn2.findIndex(function (c) {
	        return c === 'left';
	      }) >= 0 && node2IsOnFartherColumn && nodesAreOnSameRow) {
	        // console.log("Node " + node1.vector.x + "," + node1.vector.y + " is connected with " + node2.vector.x + "," + node2.vector.y + " because of RIGHT to LEFT connection", node1, node2);
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'getOppositeDirectionOf',
	    value: function getOppositeDirectionOf(direction) {
	      switch (direction) {
	        case 'up':
	          return 'down';
	          break;
	        case 'down':
	          return 'up';
	          break;
	        case 'left':
	          return 'right';
	          break;
	        case 'right':
	          return 'left';
	          break;
	      }
	    }
	  }, {
	    key: 'inBounds',
	    value: function inBounds(vector, matrix) {
	      var totalRows = matrix.length;
	      if (totalRows === 0) {
	        return false;
	      }
	      var totalColumns = matrix[0].length;
	      var x = vector.x;
	      var y = vector.y;
	      return x >= 0 && y >= 0 && x < totalColumns && y < totalRows;
	    }
	  }, {
	    key: 'getServerNode',
	    value: function getServerNode(matrix) {
	
	      for (var x in matrix) {
	        for (var y in matrix[x]) {
	          var node = matrix[x][y];
	          if (node.type === 'server') {
	            return node;
	          }
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'findNodeById',
	    value: function findNodeById(id, matrix) {
	      for (var x in matrix) {
	        for (var y in matrix[x]) {
	          var node = matrix[x][y];
	          if (node.id === id) {
	            return node;
	          }
	        }
	      }
	
	      console.warn('Failed to find node', matrix, id);
	    }
	  }, {
	    key: 'findNodeByVector',
	    value: function findNodeByVector(vector, matrix) {
	      if (!this.inBounds(vector, matrix)) {
	        return null;
	      }
	
	      if (!matrix[vector.y] && !matrix[vector.y][vector.x]) {
	        return null;
	      }
	
	      return matrix[vector.y][vector.x];
	    }
	  }]);
	
	  return Netwalk;
	})();
	
	exports['default'] = Netwalk;
	module.exports = exports['default'];

/***/ },

/***/ 239:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pureRenderDecorator = __webpack_require__(159);
	
	var _pureRenderDecorator2 = _interopRequireDefault(_pureRenderDecorator);
	
	var _radium = __webpack_require__(162);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var PlayButton = (function (_Component) {
	  _inherits(PlayButton, _Component);
	
	  function PlayButton() {
	    _classCallCheck(this, _PlayButton);
	
	    _get(Object.getPrototypeOf(_PlayButton.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(PlayButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { style: styles.base },
	          _react2['default'].createElement(
	            'button',
	            { style: styles.button, onClick: this.props.onPlay },
	            this.props.title
	          )
	        )
	      );
	    }
	  }]);
	
	  var _PlayButton = PlayButton;
	  PlayButton = (0, _radium2['default'])(PlayButton) || PlayButton;
	  PlayButton = (0, _pureRenderDecorator2['default'])(PlayButton) || PlayButton;
	  return PlayButton;
	})(_react.Component);
	
	exports['default'] = PlayButton;
	
	var styles = {
	  base: {
	    width: '100%',
	    height: '100%',
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	
	  button: {
	    color: '#8EC170',
	    backgroundColor: '#fff',
	    border: '2px solid #8EC170',
	    fontFamily: '"Helvetica Neue", "Helvetica", "Roboto", "Arial", sans-serif',
	    fontSize: '18px',
	    fontWeight: '500',
	    padding: '10px 10px',
	    '@media (min-width: 640px)': {
	      padding: '12px 12px'
	    },
	    ':hover': {
	      cursor: 'pointer',
	      border: '2px solid #609D3C',
	      color: '#609D3C'
	    }
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 240:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pureRenderDecorator = __webpack_require__(159);
	
	var _pureRenderDecorator2 = _interopRequireDefault(_pureRenderDecorator);
	
	var _radium = __webpack_require__(162);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var LevelUp = (function (_Component) {
	  _inherits(LevelUp, _Component);
	
	  function LevelUp() {
	    _classCallCheck(this, _LevelUp);
	
	    _get(Object.getPrototypeOf(_LevelUp.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(LevelUp, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { style: styles.base },
	        _react2['default'].createElement(
	          'span',
	          { style: styles.text },
	          'Too easy?'
	        ),
	        _react2['default'].createElement(
	          'button',
	          { style: styles.button, onClick: this.props.onTrigger },
	          'Add a row'
	        )
	      );
	    }
	  }]);
	
	  var _LevelUp = LevelUp;
	  LevelUp = (0, _radium2['default'])(LevelUp) || LevelUp;
	  LevelUp = (0, _pureRenderDecorator2['default'])(LevelUp) || LevelUp;
	  return LevelUp;
	})(_react.Component);
	
	exports['default'] = LevelUp;
	
	var styles = {
	  base: {
	    textAlign: 'center',
	    padding: '15px 0',
	    '@media (min-width: 640px)': {
	      padding: '25px 0'
	    }
	  },
	  text: {
	    color: '#C1C1C1',
	    fontFamily: '"Courier New", "Courier", monospace',
	    fontSize: '18px',
	    '@media (min-width: 640px)': {
	      fontSize: '24px'
	    },
	    fontWeight: '100'
	  },
	  button: {
	    backgroundColor: '#fff',
	    border: '1px solid #7B7B7B',
	    color: '#7B7B7B',
	    fontFamily: '"Courier New", "Courier", monospace',
	    fontSize: '18px',
	    '@media (min-width: 640px)': {
	      fontSize: '24px'
	    },
	    fontWeight: '100',
	    marginLeft: '15px',
	    padding: '2px 5px',
	    ':hover': {
	      border: '1px solid #B3B3B3',
	      color: '#B3B3B3',
	      cursor: 'pointer'
	    },
	    ':focus': {
	      outline: 0
	    }
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 241:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pureRenderDecorator = __webpack_require__(159);
	
	var _pureRenderDecorator2 = _interopRequireDefault(_pureRenderDecorator);
	
	var _radium = __webpack_require__(162);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var LevelDown = (function (_Component) {
	  _inherits(LevelDown, _Component);
	
	  function LevelDown() {
	    _classCallCheck(this, _LevelDown);
	
	    _get(Object.getPrototypeOf(_LevelDown.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(LevelDown, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { style: styles.base },
	        _react2['default'].createElement(
	          'button',
	          { style: styles.button, onClick: this.props.onTrigger },
	          _react2['default'].createElement(
	            'span',
	            { style: styles.short_text },
	            'Remove'
	          ),
	          _react2['default'].createElement(
	            'span',
	            { style: styles.long_text },
	            'Remove a row'
	          )
	        )
	      );
	    }
	  }]);
	
	  var _LevelDown = LevelDown;
	  LevelDown = (0, _radium2['default'])(LevelDown) || LevelDown;
	  LevelDown = (0, _pureRenderDecorator2['default'])(LevelDown) || LevelDown;
	  return LevelDown;
	})(_react.Component);
	
	exports['default'] = LevelDown;
	
	var styles = {
	  base: {
	    textAlign: 'center',
	    padding: '15px 0',
	    '@media (min-width: 640px)': {
	      padding: '25px 0'
	    }
	  },
	  text: {
	    color: '#C1C1C1',
	    fontFamily: '"Courier New", "Courier", monospace',
	    fontSize: '18px',
	    '@media (min-width: 640px)': {
	      fontSize: '24px'
	    },
	    fontWeight: '100'
	  },
	  button: {
	    backgroundColor: '#fff',
	    border: '1px solid #7B7B7B',
	    color: '#7B7B7B',
	    fontFamily: '"Courier New", "Courier", monospace',
	    fontSize: '18px',
	    '@media (min-width: 640px)': {
	      fontSize: '24px'
	    },
	    fontWeight: '100',
	    marginLeft: '15px',
	    padding: '2px 5px',
	    ':hover': {
	      border: '1px solid #B3B3B3',
	      color: '#B3B3B3',
	      cursor: 'pointer'
	    },
	    ':focus': {
	      outline: 0
	    }
	  },
	  short_text: {
	    '@media (min-width: 640px)': {
	      display: 'none'
	    }
	  },
	  long_text: {
	    '@media (max-width: 639px)': {
	      display: 'none'
	    }
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 242:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pureRenderDecorator = __webpack_require__(159);
	
	var _pureRenderDecorator2 = _interopRequireDefault(_pureRenderDecorator);
	
	var _radium = __webpack_require__(162);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var Mask = (function (_Component) {
	  _inherits(Mask, _Component);
	
	  function Mask() {
	    _classCallCheck(this, _Mask);
	
	    _get(Object.getPrototypeOf(_Mask.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Mask, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement('div', { style: {
	          width: '100%', height: '100%',
	          opacity: this.props.opacity,
	          backgroundColor: '#fff',
	          position: 'absolute',
	          top: 0,
	          left: 0
	        } });
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      opacity: _react.PropTypes.number
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      opacity: 0.9
	    },
	    enumerable: true
	  }]);
	
	  var _Mask = Mask;
	  Mask = (0, _radium2['default'])(Mask) || Mask;
	  Mask = (0, _pureRenderDecorator2['default'])(Mask) || Mask;
	  return Mask;
	})(_react.Component);
	
	exports['default'] = Mask;
	
	var styles = {};
	module.exports = exports['default'];

/***/ },

/***/ 243:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paragraph = __webpack_require__(199);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _pureRenderDecorator = __webpack_require__(159);
	
	var _pureRenderDecorator2 = _interopRequireDefault(_pureRenderDecorator);
	
	var _radium = __webpack_require__(162);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var HowToPlay = (function (_Component) {
	  _inherits(HowToPlay, _Component);
	
	  function HowToPlay() {
	    _classCallCheck(this, _HowToPlay);
	
	    _get(Object.getPrototypeOf(_HowToPlay.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(HowToPlay, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        _Paragraph2['default'],
	        null,
	        _react2['default'].createElement(
	          'strong',
	          null,
	          'How to play:'
	        ),
	        ' Click on a tile to rotate it clockwise. Your goal is to connect all tiles to the server.'
	      );
	    }
	  }]);
	
	  var _HowToPlay = HowToPlay;
	  HowToPlay = (0, _radium2['default'])(HowToPlay) || HowToPlay;
	  HowToPlay = (0, _pureRenderDecorator2['default'])(HowToPlay) || HowToPlay;
	  return HowToPlay;
	})(_react.Component);
	
	exports['default'] = HowToPlay;
	module.exports = exports['default'];

/***/ }

});


/** WEBPACK FOOTER **
 ** app.908fe3143ec89af6e911.js?
 **/